import React, { Component } from "react";
import { DragSource, DragLayer } from "react-dnd";
import { ItemTypes, Labels, starterComponent, starterProperties } from "../constants/elements";
import { getEmptyImage } from "react-dnd-html5-backend";
import styled from "styled-components";

import { VCenter, HCenter } from "../reusable/layout";
import * as Icons from "../reusable/icons";
import * as Colors from "../reusable/colors";
import { hideCatalog } from "../layout/editor";
import { linkProps } from "../spreadsheet/linker";
import { flattenDB } from "../spreadsheet/store";

const boxSource = {
  beginDrag(props, monitor) {
    hideCatalog();
    return props.elementStarter ? { starter: props.elementStarter } : {};
  },
  endDrag(props, monitor) {},
  canDrag(props, monitor) {
    return true;
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

export const ElementStyle = styled.div`
  ${VCenter};
  ${HCenter};
  height: ${p => (p.hide ? "0px" : "60px")};
  border-right: ${p => p.borderRight && "1px solid " + Colors.primary};
  border-bottom: ${p => p.borderBot && "1px solid " + Colors.primary};
  width: 100%;
  padding: 15px;
  line-height: 1.1em;
  &:hover {
    background-color: ${Colors.highLightSecondary};
  }
  cursor: ${p => (p.scene ? "pointer" : "grab")};
`;

export const icons = {
  [ItemTypes.ELEMENT_EMPTYCONTAINER]: Icons.Container,
  [ItemTypes.ELEMENT_IMAGE]: Icons.Image,
  [ItemTypes.ELEMENT_TEXT]: Icons.Text,
  [ItemTypes.ELEMENT_SLIDER]: Icons.Clone,
  [ItemTypes.ELEMENT_PROGRESSBAR]: Icons.Battery,
  [ItemTypes.ELEMENT_COUNTDOWN]: Icons.Clock,
  [ItemTypes.ELEMENT_VIDEO]: Icons.Video,
  [ItemTypes.ELEMENT_ICON]: Icons.FontAwesome
};

class Element extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  }

  render() {
    const {
      connectDragSource,
      elementType,
      isDragging,
      hidden,
      borderBot,
      borderRight
    } = this.props;
    // const Icon = icons[elementStarter || elementType];
    const label = Labels[elementType];
    return connectDragSource(
      <div
        style={{
          pointerEvents: hidden && !isDragging ? "none" : "auto",
          height: isDragging && "0px",
          zIndex: isDragging && "-300"
        }}>
        <ElementStyle borderBot={borderBot} borderRight={borderRight}>
          {label}
        </ElementStyle>
      </div>
    );
  }
}

export default DragSource(props => props.elementType, boxSource, collect)(Element);

const layerStyles = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 100,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%"
};

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: "none"
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

class CustomDragLayer_ extends Component {
  renderPreview = (type, starterProps) => {
    const sprops = starterProps || starterProperties(type);
    const linkedProps = linkProps(sprops, flattenDB.get());
    return React.createElement(starterComponent(type), {
      ...linkedProps,
      borderWidth: type === ItemTypes.ELEMENT_EMPTYCONTAINER && !starterProps ? "2px " : "0",
      children:
        sprops.children &&
        sprops.children.map((c, idx) =>
          this.renderPreview(c.type, { ...c, key: idx, position: "absolute" })
        )
    });
  };

  render() {
    const { itemType, isDragging } = this.props;
    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>{this.renderPreview(itemType)}</div>
      </div>
    );
  }
}

function collect2(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export const CustomDragLayer = DragLayer(collect2)(CustomDragLayer_);



// WEBPACK FOOTER //
// ./src/catalog/element.js